import React, { useEffect, useState } from 'react'

import { Button, ButtonProps, OverlayTrigger, Tooltip } from 'react-bootstrap'

import { useId } from 'hooks/useId'

type Props = Omit<ButtonProps, 'onClick' | 'variant'> & {
  variant?: 'warning' | 'danger'
  onClick: NonNullable<ButtonProps['onClick']>
}

export default ({
  variant = 'danger',
  ...props
}: React.PropsWithChildren<Props>): React.ReactElement => {
  const [clickedOnce, setClicked] = useState(false)
  const tooltipId = useId()

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    if (clickedOnce) {
      setClicked(false)
      props.onClick(event)
    } else {
      setClicked(true)
    }
  }

  // Get rid of the active state after some timeout
  useEffect(() => {
    if (clickedOnce) {
      const t = setTimeout(() => {
        setClicked(false)
      }, 5000)
      return () => clearTimeout(t)
    }
  }, [clickedOnce])

  return (
    <OverlayTrigger
      show={clickedOnce}
      placement="top"
      overlay={<Tooltip id={tooltipId}>Click again to confirm</Tooltip>}
    >
      <Button
        variant={clickedOnce ? variant : `outline-${variant}`}
        {...props}
        onClick={handleClick}
        onBlur={event => {
          setClicked(false)
          if (props.onBlur) {
            props.onBlur(event)
          }
        }}
      >
        {props.children}
      </Button>
    </OverlayTrigger>
  )
}
